import {useEffect, useState} from 'react';
import {Config, Recommendation, Track} from 'qon-connection';
import {useLazyQuery} from '@apollo/client';
import {GET_PRODUCT_SLIDER} from '../queries/misc';
import '../utils/base64Polyfill';
import {useConfig} from "../context/ConfigContext";

function getSkuArray(products) {
  return products && products.map(x => x._id.trim());
}


function getConditions(products) {
  const skuArray = getSkuArray(products);
  return JSON.stringify({filter:{sku:{in:skuArray}},pageSize:products.length,currentPage:1,sort:[]})
}



export const sendProductsQuarticon = async (sku, tracker) => {
  if (!tracker) {
    return null;
  }
  try {
    return await tracker.sendProductView({ id: sku });
  } catch (error) {
    // Silently fail - tracking errors should not crash the app
    console.warn('Quarticon sendProductView failed:', error.message);
    return null;
  }
};

const atob = base64 => {
  if (!base64) return null;
  if (typeof window !== 'undefined' && window.atob) {
    // For browser
    return window.atob(base64);
  } else if (typeof Buffer !== 'undefined') {
    // For Node.js
    return Buffer.from(base64, 'base64').toString('binary');
  } else {
    throw new Error('Environment does not support base64 decoding');
  }
};

export const sendTransactionQuarticon = async (product, tracker) => {
  if (!tracker) {
    return null;
  }
  try {
    const { items, reserved_order_id } = product || {};

    const transaction = {
      transactionId: reserved_order_id,
      basket:
        items &&
        items.map(x => {
          return {
            productId: x.product.sku,
            price: x.product.prices && x.product.prices.length > 0 ? x.product.prices[0].amount : 0,
            quantity: x.quantity,
          };
        }),
    };
    return await tracker.sendTransaction(transaction);
  } catch (error) {
    // Silently fail - tracking errors should not crash the app
    console.warn('Quarticon sendTransaction failed:', error.message);
    return null;
  }
};

export const useRecommendationsQuarticon = (sku, type, categoryId) => {

  const [recomendations, setRecomendations] = useState([]);

  const [productsFromQuarticon, setProductsFromQuarticon] = useState([]);
  const [query, {data, loading}] = useLazyQuery(GET_PRODUCT_SLIDER);

  // Use useEffect instead of onCompleted to avoid infinite loops
  useEffect(() => {
    if (data?.productsByCondition?.items) {
      setRecomendations(data.productsByCondition.items);
    }
  }, [data]);

  const { config } = useConfig();

  const quarticonConfig = config?.quarticon;

  const configQ = quarticonConfig && quarticonConfig.is_active &&
      new Config.Config({customerSymbol: quarticonConfig.customer_symbol, host: quarticonConfig.host_url});

  const tracker = configQ && new Track.Tracker(configQ);
  const recommendationEngine = configQ && new Recommendation.Recommendation(configQ);

  let filter = [];
  if (categoryId) {
    filter = [Recommendation.FilterApi.category(atob(categoryId))];
  } else if (sku) {
    filter = [Recommendation.FilterApi.product(sku)];
  } else {
    filter = [];
  }

  // Memoizuj recommendationEngine żeby uniknąć nieskończonych pętli
  const isReady = !!(recommendationEngine && quarticonConfig?.widget_ids?.[type]);

  useEffect(() => {
    async function getData() {
      if (!recommendationEngine || !quarticonConfig?.widget_ids?.[type]) {
        return;
      }
      try {
        const widgetData = {
          placementId: quarticonConfig.widget_ids[type],
          filters: filter,
        };
        const products = await recommendationEngine.getRecommendation(widgetData);
        if (products && products.length > 0) {
          setProductsFromQuarticon(products);
          query({variables: {condition: getConditions(products)}});
        }
      } catch (error) {
        // Silently fail - recommendation errors should not crash the app
        console.warn('Quarticon getRecommendation failed:', error.message);
      }
    }

    if (isReady) {
      getData();
    }
  }, [categoryId, type, isReady]);
  return {recomendations: recomendations, loading};
};
